
import {} from "d3-color";
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class GaugeChart extends ChartMixin {
  @Ref("container") readonly container!: HTMLElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object, required: true }) chartData: any;

  get barWidth() {
    if (this.chartData.value < -35 || this.chartData.value > 35) {
      return "50%";
    } else {
      return Math.abs((this.chartData.value * 50) / 35) + "%";
    }
  }
  get barPosition() {
    if (this.chartData.value > 0) {
      return "50%";
    } else if (this.chartData.value < -35) {
      return "0%";
    } else {
      return this.chartData.value > 0 ? "50%" : `${50 - (Math.abs(this.chartData.value) * 50) / 35}%`;
    }
  }
}
